import React, {useCallback, useMemo} from 'react';
import {Link} from 'react-router-dom';


import {ACCESS_RIGHTS, useAdminAccessRight} from 'src/hooks/access-rights';
import {useEventTracking} from 'src/hooks/useEventTracking';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

type Props = {
    accountId: number,
    licenseId: number,
    licenseType: string,
    text?: string,
    blank?: boolean,
    place: string,
};

export const AccountLicenseLink: React.FC<Props> = ({
    accountId,
    licenseId,
    licenseType,
    blank,
    place,
    text,
}) => {
    const {hasAccess} = useAdminAccessRight();
    const {accountProfileOpen} = useEventTracking();

    const linkIsAvailable = useMemo(
        () => hasAccess(ACCESS_RIGHTS.ACCOUNT_SCREEN_VIEW),
        [hasAccess],
    );

    const onTrackAccountProfileOpen = useCallback(() => {
        if (place) {
            accountProfileOpen({place});
        }
    }, [place, accountProfileOpen]);

    const content = (
        <>
            <EllipsisTextHint title={text || licenseType}>
                {text || licenseType}
            </EllipsisTextHint>
        </>
    );

    return linkIsAvailable ? (
        <Link
            to={`/profile/account/${accountId}/license-features/${licenseId}/features-and-limits`}
            onClick={onTrackAccountProfileOpen}
            target={blank ? '_blank' : undefined}>
            {content}
        </Link>
    ) : content;
};
